<template>
	<transition name="fade">
		<div class="timer" :class="{ 'danger': timeRemaining <= 10 && timeRemaining > 0 }" v-if="showTimer">
			<canvas ref="timerCanvas" height="64" width="64" class="timer-canvas"></canvas>
			<h3 class="time-label mb-0 p-2">{{ secondsToMMSS(timeRemaining) }}</h3 >			
		</div>
	</transition>
</template>

<script>
    import { $eBus } from '@/event-bus';
	import GameClientEvent from '@/enum/GameClientEvent';

	export default {
        data() {
			return {
				showTimer: false,
				timeRemaining: 0,
				duration: 0,
				ctx: null
			}
		},
		mounted() {
			$eBus.$on(GameClientEvent.RoomMessage, this.onRoomMessage);
		},
		destroyed() {
			$eBus.$off(GameClientEvent.RoomMessage, this.onRoomMessage);
		},
        methods: {
            onRoomMessage(room, message) {
				const parts = message.split(':');
                if (parts[0] == 'TimerEvent.Start') {
                    this.showTimer = true;
                    this.timeRemaining = parseInt(parts[1]);
					this.duration = this.timeRemaining;
					this.$nextTick(() => {
						this.ctx = this.$refs.timerCanvas.getContext('2d');
						this.updateTimerMask(1);
					});	
				} else if (parts[0] == 'TimerEvent.Tick') {
					const elapsed = parseInt(parts[2]);
					this.timeRemaining = this.duration - elapsed;
					if (this.ctx) {
						this.updateTimerMask(elapsed / this.duration);
					}
				} else if (parts[0] == 'TimerEvent.Complete') {				
                    this.timeRemaining = 0;
					this.updateTimerMask(0);
					this.showTimer = false;
				} else if (parts[0] == 'TimerEvent.Cancel') {           
					this.timeRemaining = 0;
					this.updateTimerMask(0);
					this.showTimer = false;
				}
			},
			secondsToMMSS(seconds) {
				const min = Math.floor(seconds / 60);
				const sec = (seconds - min * 60);
				return ('0' + min).substr(-2) + ":" + ('0' + sec).substr(-2);
			},
			updateTimerMask(t) {
				const endAngle = ((Math.PI * 2) * t) - (Math.PI / 2);
				const size = this.ctx.canvas.height;
				console.log(size);
				const halfSize = size / 2;
				this.ctx.clearRect(0, 0, size, size);
				this.ctx.globalAlpha = 0.15;
				this.ctx.beginPath();
				this.ctx.fillStyle = '#fff';
				this.ctx.arc(halfSize, halfSize, halfSize, -Math.PI / 2, endAngle, true);
				this.ctx.lineTo(halfSize, halfSize);
				this.ctx.fill();			
			}
        }
	}
</script>

<style lang="less" scoped>
	@import "~@less/variables.less";

    .timer {
		border-radius: 50%;
		background-color: @teal-dark;
        color: white;
		border-bottom: 0.4rem solid shade(@teal-dark, 20%);
		box-shadow: @shadow;
		width: @font-size-lg * 3.5;
		height: @font-size-lg * 3.5;
		display: flex;
		justify-content: center;
		align-items: center;

		position: fixed;
		left: 50px;
		bottom: 20px;

		&.danger {
			animation-name: stretch; 
			animation-duration: 0.5s; 
            animation-timing-function: ease-out-in; 
            animation-direction: alternate; 
            animation-iteration-count: infinite; 
            animation-play-state: running;
		}
	}

	.timer-canvas {
		position: absolute;
		width: 101%;
		height: 101%;
	}

	.time-label {
		font-size: @font-size-lg;
	}

	@keyframes stretch { 
		0% { 
			transform: scale(1); 
		} 

		100% { 
			transform: scale(1.15); 
		} 
	}	
</style>
